import { Block } from 'components/Shared/Layout';
import { NO_ELEMENT } from 'utils';
import styles from './styles.scss';
import { useSelector } from 'react-redux';
import { configuratorValues } from '../selector';

const messageKey = 'message';

export const NotForSaleConfigurator = () => {
  const values = useSelector(configuratorValues);

  if (values !== undefined && messageKey in values) {
    return (
      <Block>
        <p className={styles.info}>{values[messageKey]}</p>
      </Block>
    );
  }
  return NO_ELEMENT;
};
